import React, { useEffect, useState } from 'react';
import Modal from 'components/Tvendo/Common/ModalBase';
import GridItem from 'components/Grid/GridItem';
import { TextField } from '@material-ui/core';
import { wsGetAll } from 'services/WService';
import { wsPost } from 'services/WService';
import SelectAutoComplete from 'components/Tvendo/Common/SelectAutoComplete';

function AddProviderModal(props) {
  const { model, setOpen, showNotify } = props;
  const [providers, setProviders] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState();

  async function listProviders() {
    let res = await wsGetAll('base/business-partner?CardType=S&QryGroup1=Y');
    if (res.success) {
      setProviders(res.data);
    }
  }

  async function onSubmit() {
    if(selectedProvider === undefined || selectedProvider === null) {
      showNotify('Seleccione un proveedor', 'info');
      return;
    }

    let res = await wsPost('quota/provider', { base_business_partner_id: selectedProvider.id });
    if (res.success) {
      showNotify(res.message);
    }else{
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    listProviders();
  }, []);

  return (
    <Modal
      title="Agregar proveedor"
      model={model}
      setOpen={() => {
        setOpen({ open: false });
      }}
      onSubmit={onSubmit}
      entity=""
    >
      <SelectAutoComplete
        required
        label="Proveedor"
        textField="CardName"
        options={providers}
        selectedOption={selectedProvider}
        setSelectedOption={setSelectedProvider}
      />
    </Modal>
  );
}

export default AddProviderModal;
